export const activityField = `
   activity {
          attendance {
            current
            last30days
            last7days
          }
          personTypeAttendance(filterPersonType: $filterPersonType) {
            personCount
            last7days {
              within
              outwith
            }
            last30days {
              within
              outwith
            }
            current {
              within
              outwith
            }
            pubRepsAttending {
              within
              outwith
            }
          }
      }
`
